<template>
  <v-dialog
    scrollable
    :value="true"
    :transition="false"
    :persistent="false"
    @click:outside="closeDialog"
  >
    <v-card min-height="820px" class="overflow-y-hidden">
      <v-card-title class="headline"/>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="6">
            <MediaPreviewIMAGE
              hide-delete
              :file="file"
              :picker-mode="false"
            >
              <template #body>
                <v-card-subtitle class="pb-0">
                  {{ file.type }}
                </v-card-subtitle>
                <v-card-text class="text--primary">
                  {{ file.fileName }}
                </v-card-text>
                <v-card-text v-if="caption" class="pt-5">Заголовок: {{caption}}</v-card-text>
              </template>
            </MediaPreviewIMAGE>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <slot name="actions">
          <v-spacer/>
          <v-btn
            text
            color="primary darken-2"
            @click="closeDialog"
          >
            Закрыть
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MediaPreviewIMAGE from '@/components/media-file-preview/types/media-preview-IMAGE'
export default {
  name: 'PreviewDialog',
  components: {
    MediaPreviewIMAGE
  },
  props: {
    file: {
      type: Object,
      default: () => ({})
    },
    caption: {
      type: String,
      default: null
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>
